import React from "react";
import CloseIconButton from "../../../../components/CloseIconButton";
import MaterialExTable from "../../../../components/tables/MaterialExTable";
import useGetEmailLogsDetails from "../../../Utilities/EmailRecipientConfiguration/EmailLogs/hooks/useEmailLogsDetails";
import RequeueButton from "../../../../components/RequeueButton";
import { useQueryClient } from "react-query";
import { toast } from "../../../../components/toastNotification";
import useRequeueEmail from "../../EmailRecipientConfiguration/EmailLogs/hooks/useRequeueEmail";

interface EmailLogsViewModalProps {
  data: any;
  closeEmailLogsModal: () => void;
}

const EmailLogsViewModal: React.FC<EmailLogsViewModalProps> = ({
  data,
  closeEmailLogsModal,
}) => {
  const args = data.id ?? 0;
  const { data: logsDetails, isLoading } = useGetEmailLogsDetails(args);
  const queryClient = useQueryClient();
  const { mutateAsync: JobRequeue, isLoading: isRequeue } = useRequeueEmail();
  const handleRequeuButton = () => {
    JobRequeue(data, {
      onSuccess: (res) => {
        if (res.status === 200 || res.status === 201) {
          queryClient.invalidateQueries(["getEmailLogs"]);
          queryClient.invalidateQueries(["GetEmailLogsDetails"]);
          toast.fire("Success", "Email requeued successfully", "success");
        } else {
          toast.fire("Failed", "Failed to requeue email", "error");
        }
      },
      onError: (error) => {
        toast.fire("Failed", "Failed to requeue email", "error");
      },
    });
  };
  const matColumns = [
    {
      title: "Message",
      field: "message",
    },
    {
      title: "Created Date",
      field: "createdDate",
      render: (rowData) => {
        return (
          <>
            {rowData.createdDate
              ? new Date(rowData.createdDate).toLocaleDateString()
              : "unspecified"}
          </>
        );
      },
    },
    {
      title: "Created By",
      field: "createdBy",
    },
  ];
  return (
    <div className="animate-fade-in-down space-y-5">
      <div className="p-2">
        <div className="grid grid-cols-6 p-2">
          <label className="text-xs text-gray-700 text-left ml-2">
            Module Name:
          </label>
          <div className="col-span-2 expandedData fontExpand">
            {data.moduleName}
          </div>
          {/* <label className="text-xs text-gray-700 text-left ml-2">
            Sender:
          </label>
          <div className="col-span-2 expandedData fontExpand">
            {data.sender}
          </div> */}
        </div>
        <div className="grid grid-cols-6 p-2">
          <label className="text-xs text-gray-700 text-left ml-2">
            Status:
          </label>
          <div className="col-span-2 expandedData fontExpand">
            {data.status}
          </div>
        </div>
        <div className="borderSecondary my-2"></div>

        <div className="hb-2 font-bold text-primary text-xl  mx-4 pt-2">
          <div className="grid grid-cols-6 p-2">
            <div className="col-span-6 md:col-span-5">
              <div className="text-base">Email Logs Details</div>
            </div>
            <div className="col-span-6 md:col-span-1 flex items-center justify-end">
              {data.status?.toLowerCase() === "failed" ? (
                <RequeueButton
                  className={"opacity-100"}
                  disabled={false}
                  buttonText={isRequeue ? "Requeuing..." : "Requeue"}
                  onClick={() => {
                    handleRequeuButton();
                  }}
                />
              ) : (
                ""
              )}
            </div>
          </div>
          <div className="flex justify-between">
            <div className="flex items-center gap-2"></div>
            <div className="">
              <CloseIconButton onClick={closeEmailLogsModal} />
            </div>
          </div>
          <div className="w-full">
            <div className="rounded-md pt-4 pb-4">
              <MaterialExTable
                columns={matColumns}
                data={logsDetails}
                isLoading={isLoading}
                selection={false}
                setOpenModal={false}
                actions={""}
                editable={false}
                toolbar={undefined}
                showTitle={false}
                exportButton={false}
                grouping={undefined}
                search={undefined}
                detailPanel={undefined}
                selectedRows={[]}
                onSelectionChange={undefined}
                isActive={true}
                paging={true}
                searchFieldAlignment={undefined}
                toolbarButtonAlignment={undefined}
                toolBarComponent={undefined}
                panelWidth={""}
                tableRef={undefined}
                onSearchChange={undefined}
                fileName={undefined}
                title={undefined}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default EmailLogsViewModal;
